var Vendd = (function (Vendd) {
    'use strict';

    Vendd.TransactionsHistory = (function (TransactionsHistory) {

        TransactionsHistory.Messages = (function (Messages) {

            Messages.GetAccountDetails = function (accountId, transactionCode) {
                var data = {
                    accountId: accountId,
                    transactionCode: transactionCode
                }
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.TransactionsHistory.Messages.GetAccountDetails', data);
            };
            Messages.GetAccountDetails.className = 'Vendd.TransactionsHistory.Messages.GetAccountDetails';

            Messages.GetAccountDetailsSuccess = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.TransactionsHistory.Messages.GetAccountDetailsSuccess', response);
            };
            Messages.GetAccountDetailsSuccess.className = 'Vendd.TransactionsHistory.Messages.GetAccountDetailsSuccess';

            Messages.GetAccountDetailsFailure = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.TransactionsHistory.Messages.GetAccountDetailsFailure', response);
            };
            Messages.GetAccountDetailsFailure.className = 'Vendd.TransactionsHistory.Messages.GetAccountDetailsFailure';

            return Messages;

        })(TransactionsHistory.Messages || {});

        return TransactionsHistory;

    })(Vendd.TransactionsHistory || {})

    return Vendd;

})(Vendd || {});
